import { useServiceAreaAvailable } from "../use-service-area";

/**
 * Whether an after-sales screen exists for this member in this workspace: the module is switched on, the plan includes it
 * (the nav link is there and not locked) and the member may view it (assets for Assets and Installations, visits for Field
 * visits). Entry points outside the screens themselves (organisation tabs, ticket context sections) use this, so a
 * ticketing-only workspace never sees them.
 */
export function useAfterSalesAccess(area: "assets" | "installations" | "visits"): boolean {
  return useServiceAreaAvailable(area);
}
